export default (funcName, ...args) => ({
  computed: {
    _watcherTmp () {
      return {
        func: this[funcName],
        args: _.map(args, arg => this[arg])
      }
    }
  },

  watch: {
    $route (to, from) {
      if (from.name === "login") {
        const tmp = this._watcherTmp

        console.info('just get back from login page, reloading data...')
        tmp.func(...tmp.args)
      }
    },
  },
})



// WEBPACK FOOTER //
// ./client/mixins/routeWatcher.js